var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNexusPremier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.19043,33.9834v12a.7502.7502,0,0,0,.75.75h28a.7502.7502,0,0,0,.75-.75v-12a.7502.7502,0,0,0-.75-.75h-28A.7502.7502,0,0,0,25.19043,33.9834Zm1.5.75h26.5v10.5h-26.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.94043,
    y: 39.2334,
    width: 12,
    height: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.416,21.36084,48.252,22.606c7.10059-4.77344,9.77051-3.48047,11.15821-2.09229C60.793,21.897,62.08691,24.54883,57.377,31.58252l1.2461.835c4.05273-6.05225,4.63965-10.17187,1.84765-12.96436C57.708,16.68994,53.43555,17.31348,47.416,21.36084Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.24121,47.56592c-4.043,6.04-4.624,10.15429-1.831,12.94775a5.64977,5.64977,0,0,0,4.16211,1.72754c2.34375,0,5.23144-1.18017,8.78515-3.5581l-.834-1.24707c-7.01758,4.69531-9.669,3.40087-11.05274,2.01708S17.791,55.418,22.4873,48.3999Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.41016,19.45312c-2.79786,2.79737-2.19141,6.94043,1.9082,13.03956l1.24414-.83692C17.794,24.56152,19.085,21.89941,20.4707,20.51367c1.3877-1.38721,4.041-2.68555,11.06934,2.01807l.834-1.2461C26.40918,17.29248,22.168,16.69336,19.41016,19.45312Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.63965,47.55127l-1.2461.834c4.70215,7.02491,3.40235,9.68116,2.01661,11.06787C58.03125,60.832,55.38379,62.126,48.35645,57.42139l-.834,1.24658c3.56152,2.38379,6.45215,3.56689,8.79688,3.56689a5.63875,5.63875,0,0,0,4.15136-1.72119C63.22949,57.75342,62.63086,53.51318,58.63965,47.55127Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.69043,23.9834V11.794l2.71973,2.71972,1.06054-1.06055-4-4a.74973.74973,0,0,0-1.06054,0l-4,4,1.06054,1.06055L39.19043,11.794V23.9834Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.19043,55.9834V68.17285L36.4707,65.45312l-1.06054,1.06055,4,4a.74971.74971,0,0,0,1.06054,0l4-4-1.06054-1.06055-2.71973,2.71973V55.9834Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.41016,44.51367l1.06054-1.06055L11.751,40.7334H21.94043v-1.5H11.751l2.71972-2.71973-1.06054-1.06055-4,4a.74973.74973,0,0,0,0,1.06055Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4707,44.51367l4-4a.74973.74973,0,0,0,0-1.06055l-4-4-1.06054,1.06055,2.71972,2.71973H57.94043v1.5H68.12988l-2.71972,2.71972Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.41016,9.45312l-4,4,1.06054,1.06055L65.94043,11.044l3.46973,3.46972,1.06054-1.06055-4-4A.74973.74973,0,0,0,65.41016,9.45312Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.94019,
    cy: 40,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.94019,
    cy: 40,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNexusPremier);
export default __webpack_public_path__ + "static/media/icon_nexus_premier.ce8ebc6f12f7cb1ff7ddd1fdf9629608.svg";
export { ForwardRef as ReactComponent };